'use strict';

const Mn = require('backbone.marionette');
require('backbone.stickit');
const Uploader = require('../content/uploader');
const URIObjectAPI = require('data/infra/api/object/index');
const Template = require('../../template/modal/content-edit.hbs');
const UploadTabTemplate = require('../../template/modal/upload-tab.hbs');
const URITabTemplate = require('../../template/modal/uri-tab.hbs');
const EmptyTabTemplate = require('../../template/modal/empty-tab.hbs');

const UploadTabView = Mn.View.extend({
    template: UploadTabTemplate,
    regions: {
        uploader: '.content-uploader'
    },
    modelEvents: {
        'change:name': 'uploadable',
        'change:storageObjectId': 'uploadable'
    },
    bindings: {
        'input.nameUpload': 'name'
    },
    childViewEvents: {
        'addedfile': 'onAddedFile', //Uploader
        'success': 'onSuccess' //Uploader
    },

    onRender: function() {
        // 始めから file が渡ってきている場合は `file` に値が入る
        const file = this.getOption('file');
        const project = this.getOption('project');
        this.showChildView('uploader', new Uploader({
            projectId: project.id
        }));

        if(file) {
            const uploader = this.getChildView('uploader');
            uploader.on('ready', () => {
                uploader.addFile(file);
            });
        }

        this.stickit(this.model);
    },

    onAttach: function() {
        $.material.init();
    },

    onAddedFile: function(file) {
        this.trigger('formEmpty');
        this.model.set({name: file.name});
    },

    onSuccess: function(file, j) {
        this.model.set({
            storageObjectId: j.id,
            thumbnailURI: j.thumbnailURI,
            uploaded: true
        });
    },

    uploadable: function() {
        if(this.model.get('name') && this.model.get('storageObjectId')) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },

    getModel: function() {
        return this.model;
    }
});

const URITabView = Mn.View.extend({
    template: URITabTemplate,
    modelEvents: {
        'change:name': 'uploadable',
        'change:uri': 'uploadable'
    },
    bindings: {
        'input.nameURI': 'name',
        'input.uri': 'uri'
    },

    onRender: function() {
        this.stickit(this.model);

        this.listenTo(this.model, 'change:uri', () => {
            if(!this.model.get('uri')) {
                return;
            }

            URIObjectAPI.getURIObject(this.model.get('uri'))
                .then(obj => {
                    if(!this.model.get('name')) {
                        this.$('input.nameURI').val(obj.title);
                        this.$('input.nameURI').trigger('input');
                    }
                });
        });
    },

    onAttach: function() {
        $.material.init();
    },

    uploadable: function() {
        if(this.model.get('name') && this.model.get('uri')) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },

    getModel: function() {
        return this.model;
    }
});

const EmptyTabView = Mn.View.extend({
    template: EmptyTabTemplate,
    modelEvents: {
        'change:name': 'uploadable'
    },
    bindings: {
        'input.nameEmpty': 'name'
    },

    /**
     * 空のデータは URI と StorageObjectId がともに null
     */
    initialize: function() {
        this.model.set({
            uri: null,
            storageObjectId: null
        });
    },

    onRender: function() {
        this.stickit(this.model);
    },

    onAttach: function() {
        $.material.init();
    },

    uploadable: function() {
        if(this.model.get('name')) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },

    getModel: function() {
        return this.model;
    }
});

module.exports = Mn.View.extend({
    template: Template,
    ui: {
        uploadTab: '.upload-tab',
        uriTab: '.uri-tab',
        emptyTab: '.empty-tab'
    },
    regions: {
        uploadTab: '.upload-tab-wrapper',
        uriTab: '.uri-tab-wrapper',
        emptyTab: '.empty-tab-wrapper'
    },
    childViewEvents: {
        'formFilled': 'formFilled',
        'formEmpty': 'formEmpty'
    },
    formFilled: function() {
        this.trigger('formFilled');
    },
    formEmpty: function() {
        this.trigger('formEmpty');
    },

    initialize: function() {
        this._original = this.model;
        this.model = this.model ? this.model.clone() : new Backbone.Model();
        if(this._original) {
            const dataSource = this._original.getLatestVersion().getDataSource();
            const uri = dataSource.getURI();
            this.model.set({
                uri: uri,
                storageObjectId: null,
                thumbnailURI: null
            });
        }
    },

    onRender: function () {
        this.showChildView('uploadTab', new UploadTabView({
            model: this.model.clone(),
            project: this.getOption('project'),
            file: this.getOption('file')
        }));

        this.showChildView('uriTab', new URITabView({
            model: this.model.clone()
        }));

        this.showChildView('emptyTab', new EmptyTabView({
            model: this.model.clone()
        }));

        this.stickit(this.model);

        this.model = this.getChildView('uploadTab').getModel();

        this.ui.uploadTab.on('show.bs.tab', () => {
            this.model = this.getChildView('uploadTab').getModel();
            this.getChildView('uploadTab').uploadable();
        });
        this.ui.uriTab.on('show.bs.tab', () => {
            this.model = this.getChildView('uriTab').getModel();
            this.getChildView('uriTab').uploadable();
        });
        this.ui.emptyTab.on('show.bs.tab', () => {
            this.model = this.getChildView('emptyTab').getModel();
            this.getChildView('emptyTab').uploadable();
        });

        return this;
    },

    onAttach: function() {
        $.material.init();
    },

    getContent: function () {
        return {
            name: this.model.get('name'),
            uri: this.model.get('uri'),
            storageObjectId: this.model.get('storageObjectId'),
            thumbnailURI: this.model.get('thumbnailURI'),
            uploaded: this.model.get('storageObjectId') ? true : false
        }
    },

});



// WEBPACK FOOTER //
// ./data/ui/view/modal/content-edit.js